import { render, staticRenderFns } from "./TheCodeDetail.vue?vue&type=template&id=7a934dd2"
import script from "./TheCodeDetail.vue?vue&type=script&lang=js"
export * from "./TheCodeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports